const aboutbond = {
    "About Bonds": [
        {
          question: "What are Bond?",
          answer: "A bond is an instrument through which corporates borrow money from other institutions and retail investors. The investors earn a fixed rate of interest on the bond at defined intervals and the principal amount is repaid on maturity."
        },
        {
          question: "What is a coupon?",
          answer: "Coupon is the rate of interest that is paid on the investment value of the bond."
        },
        {
          question: "What is the difference between coupon rate and Yield?",
          answer: "The Coupon is the rate of interest that the investor will receive over the period of the bond. Whereas YTM refers to the return that the investor will earn if he holds the bond till maturity. When the Price of the bond is equal to the Face Value, the Coupon rate and the yield would be the same. When Price is greater than Face value, the Coupon is greater than the yield and vice versa."
        }
      ],
  }
  
  export default aboutbond;